import axios from "./configs/axiosConfig";

export const getInvoiceDetailsByInvoiceId = async (invoiceid) => {
  const url = `/invoices/invoicedetails/${invoiceid}`;
  return await axios.get(url);
};

export const getInvoices = async (dealerId,tenantId,jobNumber) => {
  const jobNumberQuery = jobNumber ? `&jobNumber=${jobNumber}`:''
  const url = `/invoices?dealerId=${dealerId}&tenantId=${tenantId}${jobNumberQuery}`;
  return await axios.get(url);
};

export const getInvoiceSummaryList = async () => {
  return await axios.get(`/invoices/summarylist`);
};


export const updateInvoiceItemSkuByInvoiceItemId = async (invoiceItemId, itemSKUName) => {
  const url = `/invoices?invoiceItemId=${invoiceItemId}&itemSKUName=${itemSKUName}`;
  
    console.log("updateInvoiceItemSkuByInvoiceItemId url: ", url);
      console.log("updateInvoiceItemSkuByInvoiceItemId id: ", invoiceItemId);
        console.log("updateInvoiceItemSkuByInvoiceItemId itemSKUName: ", itemSKUName);
  return await axios.patch(url);
};
